var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector74(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 448,
    height: 512,
    viewBox: "0 0 448 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M313.6 304C284.9 304 271.1 320 224 320C176.9 320 163.2 304 134.4 304C60.2 304 0 364.2 0 438.4V464C0 490.5 21.5 512 48 512H400C426.5 512 448 490.5 448 464V438.4C448 364.2 387.8 304 313.6 304ZM400 464H48V438.4C48 390.8 86.8 352 134.4 352C149 352 172.7 368 224 368C275.7 368 298.9 352 313.6 352C361.2 352 400 390.8 400 438.4V464ZM224 288C303.5 288 368 223.5 368 144C368 64.5 303.5 0 224 0C144.5 0 80 64.5 80 144C80 223.5 144.5 288 224 288ZM224 48C276.9 48 320 91.1 320 144C320 196.9 276.9 240 224 240C171.1 240 128 196.9 128 144C128 91.1 171.1 48 224 48Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector74);
export default __webpack_public_path__ + "static/media/Vector (74).868a7041e051d1834de4b7a82d08a10f.svg";
export { ForwardRef as ReactComponent };